import { ExternalLink } from "lucide-react";
import { Button } from "@shared/ui/Button";
import GenericUploadInput, { fileToBase64 } from "./GenericUploadInput";
import { FieldBaseProps } from "@shared/features/form/useFieldProps";

const FILE_UPLOADER_HASH = "resume-upload";

const MAX_FILE_SIZE = 20 * 1024 * 1024;

const ALLOWED_RESUME_FILE_TYPES = {
  "application/pdf": true,
  "application/msword": true,
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    true,
  "application/x-pdf": true,
  "application/acrobat": true,
  "application/vnd.pdf": true,
  "text/pdf": true,
  "text/x-pdf": true,
};

export type ResumeUploadInputProps = FieldBaseProps & {
  name: string;
};

export function ResumeUploadInput({
  name,
  required,
  error,
  isSubmitting,
  className,
}: ResumeUploadInputProps) {
  return (
    <GenericUploadInput
      name={name}
      hash={FILE_UPLOADER_HASH}
      maxFileSize={MAX_FILE_SIZE}
      required={required}
      error={error}
      isSubmitting={isSubmitting}
      className={className}
      allowedFileTypes={ALLOWED_RESUME_FILE_TYPES}
      acceptedFileTypes="PDF, DOC, or DOCX"
      transform={async (file) => {
        const base64 = await fileToBase64(file);
        return {
          file: base64,
          name: file.name,
          size: file.size,
          type: file.type,
          original: file,
        };
      }}
      renderDetails={(file) => {
        const name = file instanceof File ? file.name : "Uploaded CV";

        return (
          <a href={file.file} target="_blank" rel="noopener noreferrer">
            <Button variant="ghost" iconComponent={ExternalLink}>
              {name}
            </Button>
          </a>
        );
      }}
      changeButtonLabel="Change CV"
    />
  );
}

export default ResumeUploadInput;
